import type { FormikValues } from 'formik';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';

import { FormModal } from '../../../../../components/Formik';
import { createProduct } from '../../../../../redux/safescarf/products/actions';
import { fetchProductTypes } from '../../../../../redux/safescarf/productTypes/actions';

import type { RootState } from '@/redux/store';

export interface CreateProductFormModalProps {
  onSubmit: () => void;
  onCancel: () => void;
}

const CreateProductFormModal: React.FC<CreateProductFormModalProps> = ({ onSubmit, onCancel }) => {
  const dispatch = useDispatch();
  const productTypes = useSelector((state: RootState) => state.safescarf.productTypes);

  useEffect(() => {
    if (!productTypes.length) {
      dispatch(fetchProductTypes());
    }
  }, [productTypes.length, dispatch]);

  const fields = [
    {
      fieldType: 'text',
      name: 'name',
      label: 'Name',
    },
    {
      fieldType: 'text',
      name: 'description',
      label: 'Description',
    },
    {
      fieldType: 'select',
      name: 'prod_type',
      label: 'Product Type',
      menuItems: productTypes.map(productType => ({
        value: productType.id,
        label: productType.name,
      })),
    },
  ];

  const initialValues = {
    name: '',
    description: '',
    prod_type: '',
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Required'),
    description: Yup.string().required('Required'),
    prod_type: Yup.string().required('Required'),
  });

  const handleSubmit = (formValues: FormikValues): void => {
    onSubmit();
    dispatch(createProduct({ ...formValues }));
  };

  return (
    <FormModal
      title='Create New Product'
      fields={fields}
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      onCancel={onCancel}
      submitLabel='Create'
    />
  );
};

export default CreateProductFormModal;
